import { styled } from "@mui/material/styles";

export const ScenarioStreetsWithBarrierLegend = styled("div")`
  width: 20px;
  transform: rotate(135deg);
  height: 4px;
  border-radius: 2px;
  border: 0.5px solid #000000;
`;
